import React from 'react';
import classnames from 'classnames';
import { PapiBadge } from '@wix/da-papi-types';
import s from './Badge.scss';

export interface Props {
  badge: PapiBadge;
  size?: 16 | 24 | 68 | 100 | 164;
  type?: 'normal' | 'huge';
  className?: string;
}

const Badge: React.FC<Props> = ({ badge, size = 24, type = 'normal', className }) => {
  const { title: badgeTitle, description, stackCount, assets } = badge;
  let title = badgeTitle;
  if (description) {
    title += `: ${description}`;
  }
  if (stackCount) {
    title += ` (${stackCount})`;
  }

  const compositeKey = type === 'normal' ? 'normalComposite' : 'hugeComposite';
  const images = assets?.[compositeKey]
    ? assets[compositeKey]?.map(i => i.imageUrl)
    : [assets?.[type]];

  return (
    <div className={classnames(s['root'], s[`size-${size}`], className)} title={title}>
      {images
        ?.filter(i => i)
        .map(image => (
          <img key={image} src={image} className={s['image']} alt={title} loading="lazy" />
        ))}
    </div>
  );
};
Badge.displayName = 'Badge';

export default Badge;
